import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { DeliveryAction } from "./DeliveryAction.js";
import { CHROMA_VALUE_TO_CHROMA_MODEL_ENUM, CHROMA_MODEL_ENUM_TO_CHROMA_VALUE, ACTION_TYPE_TO_QUALITY_MODE_MAP } from "../../internal/internalConstants.js";
/**
 * @description Controls the quality of the delivered image or video.
 * @memberOf Actions.Delivery
 * @extends {Actions.Delivery.DeliveryAction}
 * @see Visit {@link Actions.Delivery|Delivery} for an example
 */
var DeliveryQualityAction = /*#__PURE__*/function (_DeliveryAction) {
  /**
   * @param {Qualifiers.Quality} qualityValue a Quality value
   */
  function DeliveryQualityAction(qualityValue) {
    _classCallCheck(this, DeliveryQualityAction);
    return _callSuper(this, DeliveryQualityAction, ['q', qualityValue.toString(), 'level']);
  }
  /**
   * Selet the Chroma sub sampling</br>
   * <b>Learn more</b>: {@link https://cloudinary.com/documentation/image_optimization#toggle_chroma_subsampling|Toggling chroma subsampling}
   * @param {420 | 444 | number} type The chroma sub sampling type
   */
  _inherits(DeliveryQualityAction, _DeliveryAction);
  return _createClass(DeliveryQualityAction, [{
    key: "chromaSubSampling",
    value: function chromaSubSampling(type) {
      this._actionModel.chromaSubSampling = CHROMA_VALUE_TO_CHROMA_MODEL_ENUM[type];
      var qualityWithSubSampling = new QualifierValue([this._actionModel.level, type]);
      qualityWithSubSampling.setDelimiter(':');
      // We either have chroma or quantization, but not both
      return this.addQualifier(new Qualifier('q', qualityWithSubSampling));
    }
    /**
     * Controls the final quality by setting a maximum quantization percentage
     * @param {number} val
     */
  }, {
    key: "quantization",
    value: function quantization(val) {
      this._actionModel.quantization = val;
      var qualityWithQuantization = new QualifierValue([this._actionModel.level, "qmax_".concat(val)]).setDelimiter(':');
      // We either have chroma or quantization, but not both
      return this.addQualifier(new Qualifier('q', qualityWithQuantization));
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var level = actionModel.level,
        chromaSubSampling = actionModel.chromaSubSampling,
        quantization = actionModel.quantization;
      var levelType = ACTION_TYPE_TO_QUALITY_MODE_MAP[level] || level;
      var result = new this(levelType);
      if (chromaSubSampling) {
        //Turn strings like 'CHROMA_420' to 420
        var chromaValue = CHROMA_MODEL_ENUM_TO_CHROMA_VALUE[chromaSubSampling.toUpperCase()];
        chromaValue && result.chromaSubSampling(+chromaValue);
      }
      quantization && result.quantization(quantization);
      return result;
    }
  }]);
}(DeliveryAction);
export { DeliveryQualityAction };